import { Component, OnInit } from '@angular/core';
import { ObjectObservable } from "../../shared/base/object-observable";
import { Syllabus } from "../shared/syllabus";
import { ActivatedRoute } from "@angular/router";
import { Course } from "../../courses/shared/course";
import { CourseService } from "../../courses/shared/course.service";
import { APPCONFIG } from "../../config";
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { MESSAGE_COMMON_ERROR, MESSAGE_EDIT_SUCCESS } from "../shared/message";
import { storage } from 'firebase';

@Component({
  selector: 'app-syllabus-edit',
  templateUrl: './syllabus-edit.component.html',
  styleUrls: ['./syllabus-edit.component.scss']
})
export class SyllabusEditComponent implements OnInit {

  courseObservable: ObjectObservable<Course>;
  course: Course;
  AppConfig: any;
  isDragOver: boolean;
  isUploaded = true;

  constructor(
    private route: ActivatedRoute,
    private courseServcie: CourseService,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
    this.route.parent.data.subscribe((data: {course: ObjectObservable<Course>}) => {
      this.courseObservable = data.course;
      this.courseServcie.readChild(data.course.$ref.key).subscribe(course => {
        this.course = course;
      })
    });
  }

  async onSubmit(value: Syllabus) {
    try {
      this.course.syllabus = value;
      await this.courseServcie.update(this.course.$key, this.course);
    } catch (e) {
      this.handleError(e);
    }
  }

  private handleSuccess() {
    this.openSnackBar(MESSAGE_EDIT_SUCCESS);
  }

  private handleError(error: any) {
    this.openSnackBar(MESSAGE_COMMON_ERROR);
  }

  private openSnackBar(message) {
    const config = new MatSnackBarConfig();
    config.duration = 3000;
    this.snackBar.open(message, null, config);
  }

  onFileOver(isOver: boolean) {
    this.isDragOver = isOver;
  }

  async onFileDrop(file: File) {
    try {
      this.isUploaded = this.isDragOver;
      const snapshot = await storage().ref(`/syllabus-attachments/${this.course.name}/${file.name}`).put(file);
      this.course.syllabus.mainTitleBackgroundImg = snapshot.downloadURL;
      this.onSubmit(this.course.syllabus);
    }catch (e) {
      this.handleError(e);
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-edit/syllabus-edit.component.ts